import { SearchConfig } from '@/components/page-model/typing';
import { reactive } from 'vue';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import moment from 'moment';
import { config } from '@/components/page-model/mjstock/mjstock-operationlog-config';

export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  return {
    update_model_config: update_model_config,
    update_model_config_options: update_model_config_options,
  };
};
